export default {
  menu: {
    dashboard: "仪表盘",
    orderManage: "订单管理",
    orderList: "订单列表",
    originalOrders: "原始订单",
    omsOrders: "OMS订单",
    originalAfterSales: "原始售后订单",
    omsAfterSales: "OMS售后订单",
    batchModifyOrder: "批量修改订单",
    returnToStorage: "退货入库",
    orderEntry: "订单录入",
    message: "客服消息",
    messageManage: "消息管理",
    question: "常见问题与回复"
  },
  form: {
    orderNumber: "订单号",
    orderType: "订单类型",
    StartTime: "开始时间",
    EndTime: "结束时间",
    SelectTime: "选择时间",
    Today: "今日",
    Yesterday: "昨日",
    Last7days: "最近7天",
    Last30days: "最近30天",
    CurrentMonth: "本月",
    LastMonth: "上个月",
    OrderTime: "下单时间"
  }
};
